import React, { PureComponent } from 'react';
import _, { update } from 'lodash';
import $ from 'jquery';
import * as HTML_RENDITION from '../utils/general/general';
import StyleTransfrom from '../utils/general/styleTransform';
import { switchPage } from '../utils/api/pageControl';
import commonStore from '../store/commonStore.js';
import { RSCH_HTML_TRACKING_CONFIG } from '../readership/trackingConfig';
import { cv_getHref } from '../cvMobile/cvHyperlink';
import * as OffCuffActions from '../actions/offCuffListStateAction';
import { enterKeyPressed, replaceAll } from '../utils/general/enterKey';
import RenditionUrlGenerator from '../utils/api/renditionUrlGenerator';

interface IHyperlinkTemplateProps {
    source: any;
    hyperLinkClassName?: string;
}

class HyperlinkTemplate extends PureComponent<IHyperlinkTemplateProps, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            isRightClickedUrl: false
        }
    }

    handleMouseDown = (event: any) => {
        event.preventDefault();
        if (event.button === 2) {
            this.setState({ isRightClickedUrl: true });
        }
        else {
            this.setState({ isRightClickedUrl: false });
        }
      }
    

    public aTagScroll(e: any, index: number, companyName: string) {
        if (e.preventDefault) {
            e.preventDefault();
        } else {
            (window as any).event.returnValue = false;
        }
        // Important!!! Don't use react-redux mapStateToProps to get switchPageData in this file! Because when switchPageData change, it will cause reRender!
        const _pageName = commonStore.getState().commonStateReducer.switchPageData.pageName;
        if (_pageName !== 'mainPage') {
            switchPage('TocToMainPage');
        }
        const scrollEleName = e.currentTarget.getAttribute('data-scroll-to');
        if ($('#' + scrollEleName).length) {
            this.changeZippyState(scrollEleName);
        }
        // Readership tracking
        if (index === 0 && companyName === 'Data Summary') {
            RSCH_HTML_TRACKING_CONFIG.trackDataSummaryLink();
        } else if (index === 0 && companyName === 'Disclosures section') {
            $('.toggleDisclosure').focus();
        } else if (e.currentTarget.classList?.contains('left-pane-toc')) {
            RSCH_HTML_TRACKING_CONFIG.trackRHSTOCLinks( companyName);
        } else {
            RSCH_HTML_TRACKING_CONFIG.trackTOCLinks(index, companyName);
        }

        if ($(e.currentTarget).parents(".modalWindow").length && $(e.target).hasClass('pageRef')) {
            $('#modalClose').click();
        }

        if (window.HTML_RENDITION.isOffCuffList) {
            this.handleOffTheCuffDisclosureClick();
        }

        !window.HTML_RENDITION.isOffCuffList && HTML_RENDITION.bodyScrollTo(scrollEleName);
    }

    public handleOffTheCuffDisclosureClick() {
        commonStore.dispatch(OffCuffActions.expandOffCuffId([window.HTML_RENDITION.doc_id]));

        setTimeout(() => {
            const targetIframe: any = $('.off-cuff-collapse-item .show .rendition-iframe');

            const bodyDom = targetIframe.contents().find('body')[0];
            const targetIframeDisclosure: any = $(bodyDom).find('.off-the-cuff-disclosure');
            if (targetIframeDisclosure.parent().hasClass('false')) {
                targetIframeDisclosure.click();
            }

            const iframeTop = targetIframe?.offset()?.top;
            const targetIframeDisclosureTop = targetIframeDisclosure?.offset()?.top;

            iframeTop && targetIframeDisclosureTop &&
                $('html, body').animate({
                    scrollTop: iframeTop + targetIframeDisclosureTop - 40
                });
        }, 500);
    }

    public openChildDocForBBG(docUrl: string, e: any){
        e.preventDefault();

        if (_.isEmpty(docUrl)) {
            return;
        }

        if (HTML_RENDITION.isBloomBerg() ) {
            HTML_RENDITION.checkDocIdAndOpenPubicationForBBGWithDocumentURL(docUrl, true);
            return;
        }
        
        HTML_RENDITION.showLoadMask();
        setTimeout(() => {
            HTML_RENDITION.hideLoadMask();
        }, 10000);        

        window.open(docUrl, '_self');        

    }

    public openCompendiumChildDoc (docUrl: string, e: any) {
        HTML_RENDITION.showLoadMask();        
        this.handleOpenLink(docUrl, e);        
        setTimeout(() => {
            HTML_RENDITION.hideLoadMask();
        }, 10000);       
        if (HTML_RENDITION.isAppInsideCViFrame() && !HTML_RENDITION.isAppInsideCVResearchUIiFrame()){
            HTML_RENDITION.changeCVUrl(docUrl);
        }
    }

    public openLinkInBloomBerg (docUrl: string, e: any) {
        e.preventDefault();
        e.stopPropagation();
        HTML_RENDITION.checkDocIdAndOpenPubicationForBBGWithDocumentURL(docUrl, true);
    }

    public openLinkByToken (docUrl: string, e: any) {
        e.preventDefault();
        HTML_RENDITION.openLinkNewWindowByTokenAuthorization(docUrl);
    }

    public handleOpenLink (docUrl: string, e: any) {
        if (HTML_RENDITION.isBloomBerg()) {
            return this.openLinkInBloomBerg(docUrl, e);
        }
        if (HTML_RENDITION.isThirdPartyTokenAuthorization()) {
            return this.openLinkByToken(docUrl, e);
        }
    }

    /**
     * Link open requirements:
     * 1. Open new window/tab
     *    a. In Mainpage, only compendium child document open in same window as except, others links should all open new window/tab
     *    b. RHS Team Directory
     *    c. RHS Campaign
     *    d. Recommended/Popular/sticky-series inner pages
     * 2. Open in same window (If under CV frame, need updated the browser address)
     *    a. RHS Analyst and Report to Revisit links
     *    b. Company link in Focus list
     *    c. RHS stack recommended/popular link
     *    d. Compendium child page link
     *    e. Compendium child page's "Back to parent" link
     *    f. Flip translate doc link
     */
    public renderDom() {
        const { source, hyperLinkClassName } = this.props;
        const isCvFrameMapping  = window.HTML_RENDITION.initialData.cvFrameWrapping === "true";
        const menuCode = commonStore.getState().commonStateReducer.menuCode; 
        let _style = "";
        let _class = "";

        if (source.format) {
            if (source.format.style) {
                _style = source.format.style;
                _style = replaceAll(_style, 'rgb(0,162,255)', 'rgb(0,90,161)');
            }
            if (source.format.class) {
                _class = source.format.class;
            }
        }
        const disclosuresSectionText = source.text?.toLowerCase() == 'disclosures section' || source.text == 'Disclosuresのセクション';
        if (disclosuresSectionText && HTML_RENDITION.isStaticMode() && source.scrollTo == 'ToC_disclosures' && window.HTML_RENDITION.initialData.productType === 'blog') {
            source.text = 'Appendix A-1';
        }
        /**
         * For the linkTpye:
         * pageRef
         * toc
         * regular
         * document_html
         * document_pdf
         * INTERACTIVEMODEL
         */
        if (this.props.source.scrollTo) {
            return <a onClick={(e) => this.aTagScroll(e, source.index, source.text)}
                      onKeyPress={(e) => enterKeyPressed(e, this.aTagScroll.bind(this, e, source.index, source.text))}
                      style={StyleTransfrom(_style)}
                      className={source.linkType + " x-rsch-hyperlink " + _class + (hyperLinkClassName ? ' ' + hyperLinkClassName : '')}
                      data-scroll-to={this.props.source.scrollTo}
                      role="button"
                      tabIndex={0}
                      aria-label={source.linkType == 'toc' ? undefined : "scroll to " + source.text}
                      href={source.link}>{source.text}</a>;
        } else if (HTML_RENDITION.isBloomBerg()
                    && !_.isEmpty(source.linkType)
                    && source.linkType === 'document_html') {
            const href = this.getHref(source.linkType, source.link);
            return <a style={StyleTransfrom(_style)}
                        className={source.linkType + " x-rsch-hyperlink " + _class}
                        role="link"
                        aria-label={source.text}
                        target={'_self'}
                        onClick={(e) => this.openChildDocForBBG(href, e)}
                        onKeyPress={(e) => enterKeyPressed(e, this.openChildDocForBBG.bind(this, href, e))}
                        >{source.text}</a>;
        } else if (HTML_RENDITION.isCompendiumProduct()
                    && !_.isEmpty(source.linkType)
                    && source.linkType === 'document_html') {
                        let updatedLink = source.link;
                        //if source.link is not in cv frame update the link with cv frame 
                        if (!source.link.includes('/cv2/go/')) {
                            updatedLink = HTML_RENDITION.getCVFrameUrl(menuCode, source.link, 'all_research');
                            /* commented this code as it seems unused. will uncomment if required */
                            // //if current page is not opened in cv frame update the link with cv frame 
                            // if(isCvFrameMapping) {
                            //     if (!HTML_RENDITION.isAppInsideCViFrame() && !HTML_RENDITION.isAppInsideCVResearchUIiFrame()) {
                            //         source.link = updatedLink;
                            //       }
                            // } 
                        }         
            const href = this.getHref(source.linkType, source.link);
            if (_.isEmpty(source.data)) {
                return <a style={StyleTransfrom(_style)}
                    className={source.linkType + " x-rsch-hyperlink " + _class}
                    href={this.state.isRightClickedUrl ? this.getHref(source.linkType, updatedLink) : href}
                    role="link"
                    aria-label={source.text}
                    target={'_self'}
                    onClick={(e) => this.openCompendiumChildDoc(href, e)}
                    onMouseDown={(e) => this.handleMouseDown(e)}
                    onKeyPress={(e) => enterKeyPressed(e, this.openCompendiumChildDoc.bind(this, href, e))}
                >{source.text}</a>;
            } else {
                const innerHyperlink: Array<object> = [];
                source.data?.forEach((element: any) => {
                    if (element?.format !== undefined) {
                        innerHyperlink.push(<span style={StyleTransfrom(element.format.style)}
                            className={element.format.class}>{element.text}</span>);
                    } else {
                        element && innerHyperlink.push(<span>{element.text}</span>);
                    }
                });
                return <a className={source.linkType + " x-rsch-hyperlink " + _class}
                    href={this.state.isRightClickedUrl ? this.getHref(source.linkType, updatedLink) : href}
                    role="link"
                    aria-label={source.text}
                    target={'_self'}
                    onClick={(e) => this.openCompendiumChildDoc(href, e)}
                    onMouseDown={(e) => this.handleMouseDown(e)}
                    onKeyPress={(e) => enterKeyPressed(e, this.openCompendiumChildDoc.bind(this, href, e))}
                >{innerHyperlink}</a>;
            }
        } else if (_class.match('x-rsch-superscript') || _class.match('x-rsch-subscript')) {
            const linkType = source.linkType;
            const href = this.getHref(linkType, source.link);
            const innerHyperlink: Array<object> = [];
            source.data?.forEach((element: any) => {
                if (element.format !== undefined && (element.format.class === 'x-rsch-superscript' || element.format.class === 'x-rsch-subscript')) {
                    innerHyperlink.push(<span className={element.format.class}>{element.text}</span>);
                } else {
                    innerHyperlink.push(<span>{element.text}</span>);
                }
            });
            if (!source.data && source.text) {
                innerHyperlink.push(<span>{source.text}</span>);
            }
            const disabled_link = <a style={StyleTransfrom(_style)} className={linkType + " x-rsch-hyperlink disabled_link "}>{innerHyperlink}</a>;
            const regularLink = <a style={StyleTransfrom(_style)}
                className={linkType + " x-rsch-hyperlink "}
                href={href}
                role="link"
                tabIndex={0}
                aria-label={source.text}
                onClick={(e) => this.handleOpenLink(href, e)}
                onKeyPress={(e) => enterKeyPressed(e, this.handleOpenLink.bind(this, href, e))}
                target={HTML_RENDITION.setTargetValue(href)}>{innerHyperlink}</a>;

            return HTML_RENDITION.isHTMLLightRendition() ? disabled_link : regularLink;
        }
        else if (HTML_RENDITION.isHTMLLightRendition()) {
            return <span style={StyleTransfrom(_style)}
                className={source.linkType + " x-rsch-hyperlink disabled_link " + _class}
                role="button" aria-disabled="true"
                tabIndex={0}
                aria-label={source.text}>{source.text}</span>;
        }
        else {
            const linkType = source.linkType;  
            if (_.toLower(source.text) === "read more" && !source.link.includes('/cv2/go/') ) {
                source.link = HTML_RENDITION.getCVFrameUrl(menuCode, source.link, 'all_research');
            }        
            const href = this.getHref(linkType, source.link);
            const isCompendiumAuthorLink =
            (this.props.hyperLinkClassName &&
                this.props.hyperLinkClassName.toLocaleLowerCase().indexOf('cirauthordata') > -1 &&
                HTML_RENDITION.isCompendiumProduct()
            ) ? true : false;

            const linkDom =
                <a style={StyleTransfrom(_style)}
                    className={linkType + " x-rsch-hyperlink " + _class}
                    href={href}
                    role="link"
                    tabIndex={0}
                    aria-label={source.text}
                    onClick={(e) => this.handleOpenLink(href, e)}
                    onKeyPress={(e) => enterKeyPressed(e, this.handleOpenLink.bind(this, href, e))}
                    target={HTML_RENDITION.setTargetValue(href)}>{source.text}</a>;

            const deadenDom = <span className="deaden" style={{ 'fontSize': '15px' }}>{source.text}</span>;

            return (window.HTML_RENDITION.initialData.isDeaden('ANALYST_EMAIL') && isCompendiumAuthorLink) ? deadenDom : linkDom;
        }
    }

    public render() {
        return (
            <React.Fragment>
                {this.renderDom()}
            </React.Fragment>
        );
    }

    private getHref = (linkType: string, url: string) => {
        let linkUrl = url;
        if (linkType && !_.isEmpty(linkType) && 'document_html' === linkType) {
            linkUrl = HTML_RENDITION.addParentDocDataParam(url);
        }
        if (HTML_RENDITION.isCVMobileApp()) {
            linkUrl = cv_getHref(linkType, linkUrl);
        }
        return linkUrl;
    }

    private changeZippyState(location: string) {
        if (HTML_RENDITION.isCompendiumProduct() && $('#' + location).parents('.zippy').hasClass('false')){
            $('#' + location).parents('.zippy').removeClass('false').addClass('true');
            $('#' + location).parents('.body').removeClass('hide').addClass('show');
            $('#' + location).parents('.zippy').find('.zippyTogglerContainer').removeClass('closed').addClass('opened');
		}
    }
}

export default HyperlinkTemplate;